<template>
  <div>
    <el-form
      @submit.native.prevent="onSubmitTransporte"
      :model="formTransporte"
      ref="formTransporte"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item
            label="Necessidade de Transporte Escolar?"
            prop="transporte"
            :rules="[$requiredChange]"
            key="transporte"
          >
            <el-select v-model="formTransporte.transporte">
              <el-option :key="true" label="SIM" :value="true"></el-option>
              <el-option :key="false" label="NÃO" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col v-if="formTransporte.transporte" :xs="24" :sm="24" :md="24">
          <el-form-item
            label="Tipo de Transporte"
            prop="tipo_transporte_id"
            :rules="[$requiredChange]"
            key="tipo_transporte_id"
          >
            <el-select v-model="formTransporte.tipo_transporte_id">
              <el-option
                v-for="item in selectTransportes"
                :key="item.id"
                :label="item.nome"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Rota do Transporte" prop="rota" key="rota">
            <el-input v-model="formTransporte.rota" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24">
          <el-form-item class="u-text-right u-mt-15">
            <el-button type="primary" native-type="submit">SALVAR</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ["matricula"],
  data: () => ({
    formTransporte: {
      transporte: "",
      tipo_transporte_id: "",
      rota: ''
    },
    selectTransportes: [],
  }),
  mounted() {
    this.getTransportes();
  },
  methods: {
    getTransportes() {
      this.$axios
        .get(
          `${this.$store.state.config.baseUrlApi}/api/transporte/getAll`,
          this.$store.getters.getHeaderAuth
        )
        .then((response) => {
          this.selectTransportes = response.data;
        })
        .catch((error) => {
          this.$store.commit("throwException", error);
        });
    },
    onSubmitTransporte() {
      this.$refs.formTransporte.validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              `${this.$store.state.config.baseUrlApi}/api/matricula/updateTransporte/` +
                this.matricula.id,
              this.formTransporte,
              this.$store.getters.getHeaderAuth
            )
            .then((response) => {
              if (typeof response.data.throw !== "undefined") {
                window.eventBus.$emit("alert", {
                  msg: response.data.throw.msg,
                  type: response.data.throw.type,
                });
              } else {
                window.eventBus.$emit("alert", {
                  msg: "Sucesso! - Operação realizada com Sucesso!",
                  type: "success",
                });
                this.dialogTransporte = false;
                this.$emit("onSubmitTransporte");
              }

              window.eventBus.$emit("loading", false);
            })
            .catch((error) => {
              window.eventBus.$emit("loading", false);
              this.$store.commit("throwException", error);
            });
        } else {
          window.eventBus.$emit("alert", {
            msg: "Campos obrigatórios não foram preenchidos.",
            type: "warning",
          });
        }
      });
    },
  },
  watch: {
    matricula: {
      immediate: true,
      handler(value) {
        if (value) {
          this.formTransporte.transporte = value.tipo_transporte_id
            ? true
            : false;
          this.formTransporte.tipo_transporte_id = value.tipo_transporte_id;
        }
      },
    },
    "formTransporte.transporte": function (newVal, oldVal) {
      if (!newVal) {
        this.formTransporte.tipo_transporte_id = "";
      }
    },
  },
  components: {},
};
</script>
